// ex: 'a,b,c' turns into ['a','b','c']
export const envListToArray = (envList: string) =>
  envList
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean)
